import styled from '@emotion/styled'
import { hexColors } from '@mobi/settings'

/** @deprecated Use PageHeader instead */
export const ContentHeaderStyled = styled.header({
  background: hexColors.black,
  color: hexColors.white,
  padding: '1em',

  h2: {
    display: 'flex',
    alignItems: 'center',
    fontSize: '1.6rem',
    textTransform: 'uppercase',
    lineHeight: '1.2',

    svg: {
      marginRight: '0.5rem',
    },

    a: {
      color: hexColors.white,
      textDecoration: 'none',
    },
  },
})
